import styled, { keyframes } from 'styled-components'
import { rem, rgba } from 'polished'
import { breakpoints } from '../Theme'
import BaseIcon from '../Icon'
import { Text } from '../Typography'
import { DisplayProps, display } from 'styled-system'

const animation = keyframes`
 0% {
   width: 0;
 }
 100% {
   width: 100%;
 }
`

export const Container = styled.div<{ variant: string }>`
  width: 100%;
  position: relative;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
  padding: 1rem;
  border: 1px solid ${p => p.theme.colors.shades[200]};
  border-top: none;
  min-width: ${rem(300)};
  background: #fff;
  pointer-events: auto;
  user-select: none;
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
  @media screen and (min-width: ${breakpoints.small}) {
    padding: 1.5rem;
    width: auto;
  }

  @media (hover: hover) and (pointer: fine) {
    &:hover ::after {
      animation-play-state: paused;
    }
  }

  &::before {
    position: absolute;
    top: 0;
    content: '';
    left: 0;
    width: 100%;
    height: 2px;
    background: ${p => p.theme.colors.shades[200]};
  }
  &::after {
    position: absolute;
    top: 0;
    content: '';
    left: 0;
    height: 2px;
    background: ${p =>
      p.variant === 'error' ? p.theme.colors.error : p.theme.colors.bigStoneLight};
    animation: ${animation} 5s 1;
    animation-fill-mode: forwards;
  }
`

export const Image = styled.img`
  background: ${p => p.theme.colors.shades[50]};
  object-fit: contain;
  width: ${rem(40)};
  height: ${rem(40)};

  @media screen and (min-width: ${breakpoints.small}) {
    width: ${rem(56)};
    height: ${rem(56)};
  }
`

export const Icon = styled(BaseIcon)`
  background: ${p => p.theme.colors.shades[50]};
  color: ${p => p.theme.colors.shades[800]};
  width: ${rem(40)};
  height: ${rem(40)};

  @media screen and (min-width: ${breakpoints.small}) {
    width: ${rem(56)};
    height: ${rem(56)};
  }
`
export const ErrorIcon = styled(Icon)`
  background: ${p => rgba(p.theme.colors.error, 0.2)};
  color: ${p => p.theme.colors.error};
`

export const Description = styled.div<DisplayProps>`
  ${display};
  font-family: ${p => p.theme.fonts.body};
  font-size: ${rem(14)};
  line-height: 1.6;
  @media screen and (min-width: ${breakpoints.small}) {
    font-size: ${rem(12)};
    line-height: 1.45;
    margin-bottom: 0.25rem;
  }
`

export const Label = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
  text-overflow: ellipsis;
  display: block;
`
Label.defaultProps = {
  as: 'div'
}
